export default __webpack_public_path__ + "static/media/become.0c7676bc.svg";